import $ from 'jquery';
import {isMobile} from "Core/screenSizes";

import 'jquery-touchswipe';

import {MAX_DISTANCE_FOR_NOT_SWIPE, SWIPE_DIRECTION_LEFT, SWIPE_DIRECTION_RIGHT} from "./consts";
import {cancelSwipe} from "./phaseActions/cancel-swipe";
import {startGallerySwipe} from "./phaseActions/start-swipe";
import {endGalleryBlockSwipe} from "./phaseActions/end-swipe";
import {moveGalleryImages} from "./phaseActions/move-swipe";
import {bindHandlerToGalleryButtons} from './arrow-handler';

export const checkNavBtn = function (gallery) {
    let indexVisibleImage = getIndexVisibleImage(gallery);

    gallery.find('.gallery-btn-left').css('opacity', 1);
    gallery.find('.gallery-btn-right').css('opacity', 1);

    if (indexVisibleImage === 0)
        gallery.find('.gallery-btn-left').css('opacity', 0);

    if (isNextImageByIndexInGallery(gallery, indexVisibleImage))
        gallery.find('.gallery-btn-right').css('opacity', 0);
};

export const isSwipeByExtremeImage = function (gallery, distance) {
    return (isRightSwipeByFirstImage(gallery, distance) || isLeftSwipeByLastImage(gallery, distance)) &&
        Math.abs(distance) > MAX_DISTANCE_FOR_NOT_SWIPE
};

export const isLeftSwipeByLastImage = function (gallery, distance) {
    return isLastImageInGallery(gallery) && distance < 0;
};

export const isLastImageInGallery = function (gallery) {
    return getIndexVisibleImage(gallery) >= gallery.find('.material-gallery-images-container__image').length - 1;
};

export const isFirstImageInGallery = function (gallery) {
    return gallery.find('.material-gallery-images-container').position().left / gallery.width() > 0;
};

export const isRightSwipeByFirstImage = function (gallery, distance) {
    return isFirstImageInGallery(gallery) && distance > 0;
};

export const getIndexVisibleImage = function (gallery) {
    return Math.abs(Math.ceil(gallery.find('.material-gallery-images-container').position().left) / gallery.width());
};

export const isNextImageByIndexInGallery = function (gallery, index) {
    return isImageByIndexInGallery(gallery, index + 1);
};

export const isImageByIndexInGallery = function (gallery, index) {
    return gallery.find('.material-gallery-images-container__image:eq(' + index + ')').length === 0;
};
export const handlerGallerySwipe = () => {
    bindHandlerToGalleryButtons();
    $('.material-content-gallery').swipe({
        allowPageScroll: $.fn.swipe.pageScroll.VERTICAL,
        swipeStatus: function (event, phase, direction, distance) {
            if (!isMobile()) {
                return;
            }

            if ($(this).hasClass('swiped') || ['up', 'down'].indexOf(direction) !== -1) {
                return true;
            }

            switch (phase) {
                case 'start':
                    startGallerySwipe(this);
                    break;

                case 'move':
                    moveGalleryImages(this, direction === SWIPE_DIRECTION_LEFT ? distance * -1 :
                        direction === SWIPE_DIRECTION_RIGHT ? distance : 0);
                    break;

                case 'end':
                    endGalleryBlockSwipe(this, direction);
                    break;

                case 'cancel':
                    cancelSwipe(this);
                    break;
            }
        }
    });
};
